<section class="home-stats" aria-label="Company statistics">
  <div class="container">
    <div class="stats-grid">
      @for (center of widget.counters; track center.title) {
        <div class="stat-card">
          <span class="stat-value">{{ displayValue($index) }}{{ center.counterPostfix }}</span>
          <span class="stat-label">{{ center.title }}</span>
        </div>
      }
    </div>
  </div>
</section>
